import React from "react";
import TabContent from "../../../DocumentTemplate/NewTemplate/ViewMode/TabContent/TabContent";
import "./RenderedAbstract.scss";

const renderedAbstract = (props) => {
  const tab = props.parsedAbstract.find(
    ({ tabTitle }) =>
      tabTitle.toLowerCase().replace(" ", "-") === props.match.params.tab
  );
  let tempAbstract = null;

  if (tab && "tabSections" in tab) {
    tempAbstract = (
      <div
        className="mx-5 document-abstract-section"
        style={{ marginTop: "52px" }}
      >
        <TabContent
          sections={tab.tabSections}
          dropdownValueChangeHandler={props.dropdownValueChangeHandler}
          fieldValueChangeHandler={props.fieldValueChangeHandler}
          radioValueChangeHandler={props.radioValueChangeHandler}
          checkboxValueChangeHandler={props.checkboxValueChangeHandler}
          showInDocUpload={true}
        />
      </div>
    );
  }

  return tempAbstract;
};

export default renderedAbstract;
